<template>
  <van-action-sheet v-model:show="isShow" :lock-scroll="lockScroll" :title="datas.title" safe-area-inset-bottom @closed="closed">
    <div v-if="datas.content" class="box" v-html="datas.content"></div>
    <div v-else class="box">
      <slot />
    </div>
    <van-button v-if="showBtn" @click="isShow = false" type="primary" block class="btn">{{ datas.btnText || '确定' }}</van-button>
  </van-action-sheet>
</template>

<script>
import { reactive, toRefs, watch } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
export default {
  props: ['datas', 'showPopUp', 'showBtn', 'lockScroll'],
  emits: ['closed'],
  setup(props, { emit }) {
    let { datas, showPopUp, showBtn, lockScroll = true } = toRefs(props)
    const state = reactive({
      isShow: false,
      datas,
      showPopUp,
      showBtn,
      lockScroll
    })
    onBeforeRouteLeave(() => {
      state.isShow = false
    })
    watch(
      () => state.showPopUp,
      () => {
        document.body.style.position = 'fixed'
        document.body.style.overflow = 'hidden'
        document.querySelector('#app').style.overflow = 'hidden'
        state.isShow = true
      }
    )
    const closePopUp = () => {
      state.isShow = false
    }
    const closed = () => {
      document.body.style.position = 'relative'
      document.body.style.overflow = 'scroll'
      document.querySelector('#app').style.overflow = 'scroll'
      emit('closed')
    }
    return {
      ...toRefs(state),
      closePopUp,
      closed
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 20px;
  min-height: 30vh;
  overflow-y: scroll;
}
.btn {
  margin: 30px auto 60px;
  width: calc(100% - 40px);
}
</style>
